import { MaskedTempoInput } from "src/components/MaskedTempoExerciseAttributeInput";
import {
  type TempoInputProps,
  useMaskedInputRegistryHandlers,
} from "src/workouts/exerciseAttributeInput.shared";

export function TempoInput(props: TempoInputProps) {
  const registryHandlers = useMaskedInputRegistryHandlers(
    props.inputId ?? props.id ?? "tempo-input",
    props.value,
  );

  return (
    <MaskedTempoInput
      key={registryHandlers.key}
      {...props}
      registryHandlers={registryHandlers}
    />
  );
}
